<!-- =========================================================================================
    File Name: pagos_reinscripciones.vue
    Description: VaLidacion de pagos internos del area de fianzas
    ----------------------------------------------------------------------------------------
    Item Name: pagos pagos_reinscripciones
      Author: Martin vicencio
    Author URL: martin vicencio
========================================================================================== -->

<template>
  <vx-card title="Pagos Re-Inscripcion" code-toggler>

    <p>Historico de pagos </p><br>

    <vs-table search pagination :maxItems="50" stripe :data="pagos_reinscripciones">
    
      <template slot="thead">
         <vs-th>Numero</vs-th>
        <vs-th sort-key="matricula">Matricula</vs-th>
        <vs-th>Nombre</vs-th>
        <vs-th>Concepto</vs-th>
        <vs-th>Cantidad</vs-th>
        <vs-th>Referencia</vs-th>
        <vs-th>Creado</vs-th>
        <vs-th>Caducidad</vs-th>
        <vs-th>Periodo</vs-th>
        <vs-th sort-key="pagado">Pagado</vs-th>
        <!-- <vs-th>Accciones</vs-th> -->
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{indextr+1}}
          </vs-td>
          <vs-td :data="data[indextr].id">
            {{data[indextr].matricula}}
          </vs-td>
          <vs-td :data="data[indextr].nombres">
            {{data[indextr].apellidoPaterno}} {{data[indextr].apellidoMaterno}} {{data[indextr].nombres}}
          </vs-td>
          <vs-td :data="data[indextr].concepto">
            {{data[indextr].concepto}}
          </vs-td>
          <vs-td :data="data[indextr].costo">
            ${{data[indextr].costo}}
          </vs-td>
          <vs-td :data="data[indextr].referencia">
            {{data[indextr].referencia}}
          </vs-td>
          <vs-td :data="data[indextr].created">
            {{data[indextr].created}}
          </vs-td>
          <vs-td :data="data[indextr].fechaCaducidad">
            {{data[indextr].fechaCaducidad}}
          </vs-td>
         <vs-td :data="data[indextr].periodo">
            {{data[indextr].periodo}}-{{data[indextr].idAgno}}
          </vs-td>

          <vs-td :data="data[indextr].pagado">
            <div v-if="data[indextr].pagado=='SI'">
                    <span class="alert alert-success" role="alert"> {{data[indextr].pagado}}  </span>
             </div> 
                  <div v-else >
                        <span class="alert alert-danger" role="alert"> {{data[indextr].pagado}}  </span>
                              </div> 
           </vs-td>

          <!-- <vs-td style="text-align: center;"> -->
          <!-- <vs-button class="" disabled=""  @click="validar_pago(data[indextr].id)">Validar</vs-button> -->
          <!-- </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
// import vSelect from 'vue-select'
//  import AddNewDataSidebar from './AddNewDataSidebar.vue';
    import vSelect from 'vue-select'
    import Button from "../components/vuesax/button/Button";
export default {
  data() {
    return {
      // id: localStorage.getItem('id'),
      // pagos_reinscripciones: {},
     pagos_reinscripciones: [],
     
     
    }
  },
  components: {
            Button,
            // AddNewDataSidebar,
            // 'v-select': vSelect
    'v-select': vSelect,
  },
  created() {
    this.$vs.loading();
    this.getPagosInternos();
     
  },
  mounted(){
  },
  watch: {
    // whenever question changes, this function will run
  },
  methods: {
    getPagosInternos() {
      this.$http.get("pagos_reinscripciones").then(
          response => {
            // console.log(response.data)
            this.pagos_reinscripciones = response.data.pagos_reinscripciones;
            //console.log(this.kardex);
            this.$vs.loading.close();
          },
          error => {
            this.StepError(error);
          }
      );
    
      }
    // validar_pago(id){

    // }
  }

}
</script>